import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { persistReducer } from 'redux-persist';
import { openBackdrop, closeBackdrop } from '../backdrop/backdrop';
import storageSession from 'redux-persist/lib/storage/session';
import { RootState } from '../rootReducer';
import {
    ISaleListPending, ISalePaginate
} from '../../models/formSale';
import { AxiosResponse } from "axios";
import {openNotifier} from "../notifier/notifier";

const api = process.env.REACT_APP_API_URL

const initialStatePaginate: ISalePaginate = {
    response: {
        details_created: 0,
        message: "",
        total_created: 0,
        statusCode: 0
    },
    meta: {
        current_page: 1,
        per_page: '10',
        total: 0
    },
    search: '',
    // errors: null,
    IsDisableSend:true,
    loadingSale: false,
}

// Hacemos POST del excel
export const reportsAttendanceStore = createAsyncThunk<ISalePaginate,
    { datos: FormData},
    {
        rejectValue: unknown
    }
    >(
        'reportsAttendance/create',
        async( data, thunkApi ) => {
            thunkApi.dispatch( openBackdrop() );
            try{
                const response = await axios.post(`${api}/imports/asistencia`,
                    data.datos,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        responseType: 'json' as const
                    }
                    );
                thunkApi.dispatch(closeBackdrop());
                // @ts-ignore
                thunkApi.dispatch(openNotifier({open:true,variant:"success",message:`Reporte cargado Exitosamente`}))
                return await response.data;
            }catch( err ){
                thunkApi.dispatch( closeBackdrop() );
                return thunkApi.rejectWithValue("error");
            }
        }
)

export const SendReportsAttendance = createAsyncThunk<ISalePaginate,
    { },
    {
        rejectValue: unknown
    }
>(
    'reportsAttendance/send',
    async( data, thunkApi ) => {
        thunkApi.dispatch( openBackdrop() );
        try{
            const response = await axios.get(`${api}/enviarAsistencias`);
            thunkApi.dispatch(closeBackdrop());
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:`Reporte Enviado Exitosamente`}))
            return await response.data;
        }catch( err ){
            thunkApi.dispatch( closeBackdrop() );
            return thunkApi.rejectWithValue("error");
        }
    }
)
export const reportsAttendanceSlice = createSlice({
    initialState: initialStatePaginate,
    name: "reportsAttendance",
    extraReducers: builder => {
        builder
        .addCase(reportsAttendanceStore.pending, state => {
            state.loadingSale = true;
        })
        .addCase(reportsAttendanceStore.fulfilled, (state = initialStatePaginate, {payload}) => {
            state.loadingSale = false;
            state.IsDisableSend=false
        })
        .addCase(reportsAttendanceStore.rejected, (state, action) => {
            state.loadingSale = false;
        })
        .addCase(SendReportsAttendance.pending, state => {
                state.loadingSale = true;
            })
        .addCase(SendReportsAttendance.fulfilled, (state = initialStatePaginate, {payload}) => {
                state.loadingSale = false;
                state.IsDisableSend=true
            })
       .addCase(SendReportsAttendance.rejected, (state, action) => {
                state.loadingSale = false;
            })
    },
    reducers: {},
});

export const reportsAttendanceReducer = reportsAttendanceSlice.reducer;
export const attendanceSelector = ( state: RootState ) => state.attendance;
